export default __webpack_public_path__ + "static/media/discover.ba7c42ec.png";